import { Button, Radio } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setGApiKeyUpdate, UpdateSetApiKey } from '../../store/common/common_action'
import { isEmpty } from './helper'
import Lineinput from './lineinput'
import Modal from './modal'
import { useTranslation } from '../../i18n/I18nProvider'

const APIKeyUpdateModal = (props) => {
    const { translations } = useTranslation()
    const pf = translations?.profile || {}
    const cs = translations?.common || {}
    const { updateModal, updateAlert } = { ...props }
    const dispatch=useDispatch()
    const common = useSelector((state) => state?.common)
    const {loginData,setGApiKey}=common
    const [selectedRadio, setSelectedRadio] = useState(1)
    const [apiKey, setApiKey] = useState(JSON.parse(sessionStorage.getItem('APIKEY')) || "")
    const [displayName, setDisplayName] = useState(JSON.parse(sessionStorage.getItem('DisplayName')) || "")
    const [displayId, setDisplayId] = useState(JSON.parse(sessionStorage.getItem('DisplayId')) || "")
    const [updateApi, setApiUpdate] = useState(1)
    const onSave = () => {
        if (apiKey === "") {
            updateAlert({ show: true, msg: pf.fillApiKey || 'Fill API Key', nextId: '' })
        } else {
            sessionStorage.setItem("APIKEY", JSON.stringify(apiKey) || "")
            sessionStorage.setItem("APIKEYVelid", JSON.stringify(false) || "")
            sessionStorage.setItem("DisplayName", JSON.stringify(displayName) || "")
            sessionStorage.setItem("DisplayId", JSON.stringify(displayId) || "")
            const obj={
                intCompanyID:loginData?.intCompanyID,
                intBranchID:loginData?.intBranchID,
                strApiKey:apiKey || "",
                Email:"",
                DisplayName:displayName,
                DisplayID:displayId
            }
            dispatch(setGApiKeyUpdate(obj))
            // setApiUpdate(false)
            const url = `https://maps.googleapis.com/maps/api/js?key`
            var scripts = document.getElementsByTagName('script')
            for (var i = scripts?.length; i--;) {
                if (scripts[i].src.includes(url)){
                    //remove
                    scripts[i].src=""
                } 
            }
      
        }
    }
    useEffect(() => {
        if(!isEmpty(setGApiKey)){
            if(setGApiKey?.Data?.Table?.length>0){
               setApiUpdate(2)
               dispatch(UpdateSetApiKey({}))
            }else{
               setApiUpdate(3)
            }
        }
    }, [setGApiKey])
    
    return (
        <>
            <Modal
                headTxt={pf.updateGoogleMapApiKey || 'Update Google Map API Key'}
                width={updateApi==1 ? '60%' : "30%"}
                updateModal={updateModal}
            >
                {updateApi==1 ? <Stack className="APIKeyUpdate">
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ background: '#FFF' }}
                    >
                        <Box className="topSection">
                            <Box className="topSection-left" onClick={() => setSelectedRadio(1)}>
                                <Radio
                                    id={'isHaveAPIKey'}
                                    name={`haveAPIKey`}
                                    size={'medium'}
                                    value={1}
                                    checked={selectedRadio === 1}
                                />
                                {pf.iHaveGoogleCloudConsoleAndMapApiKeys || 'I have Google Cloud Console and Map API Keys'}
                            </Box>
                            <Box className="topSection-right" onClick={() => setSelectedRadio(2)}>
                                <Radio
                                    id={'isHaveAPIKey'}
                                    name={`haveAPIKey`}
                                    size={'medium'}
                                    value={2}
                                    checked={selectedRadio === 2}
                                />
                                {pf.createGoogleCloudConsoleAndMapApiKeys || 'Create Google Cloud Console and Map API Keys'}
                            </Box>
                        </Box>
                    </Stack>
                    {
                        selectedRadio === 1 ?
                            <>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ background: '#FFF' }}
                                    className="APIKeyFirstTab"
                                >
                                    <Box className="APIKeyUpdate-left">
                                        <Box className="allinputs-label">
                                            <Box className="inputs-label">
                                                <p>{pf.apiKeyId || 'API Key ID'}</p>
                                                <Box className="inputBox">
                                                    <div
                                                        className={'input--wrapper'}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <Lineinput
                                                            label={''}
                                                            type="text"
                                                            name="APIKEYID"
                                                            value={apiKey}
                                                            onChange={(e) => setApiKey(e.target.value)}
                                                        />
                                                    </div>
                                                </Box>
                                            </Box>
                                            <Box className="inputs-label">
                                                <p>{pf.displayName || 'Display Name'}</p>
                                                <Box className="inputBox">
                                                    <div
                                                        className={'input--wrapper'}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <Lineinput
                                                            label={''}
                                                            type="text"
                                                            name="APIKEYID"
                                                            placeholder={pf.optional || '(Optional)'}
                                                            value={displayName}
                                                            onChange={(e) => setDisplayName(e.target.value)}
                                                        />
                                                    </div>
                                                </Box>
                                            </Box>
                                            <Box className="inputs-label">
                                                <p>{pf.displayId || 'Display ID'}</p>
                                                <Box className="inputBox">
                                                    <div
                                                        className={'input--wrapper'}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <Lineinput
                                                            label={''}
                                                            type="text"
                                                            name="APIKEYID"
                                                            placeholder={pf.optional || '(Optional)'}
                                                            value={displayId}
                                                            onChange={(e) => setDisplayId(e.target.value)}
                                                        />
                                                    </div>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className="APIKeyUpdate-right">
                                        <Box className="right-instructions">
                                            <div style={{ color: "#444444", fontWeight: "600" }}>{pf.apiKeyIdColon || 'API Key ID:'}</div>
                                            <div>{pf.ensureApiKeyNotRestricted || '1. Ensure the API Key ID is not application restricted'}</div>
                                            <div>{pf.ensureApisEnabled || '2. Ensure that following APIs are enabled for this API Key ID:'}</div>
                                            <div><span>-</span> {pf.placesAndGeocodingApis || 'Places API, Geo Coading API'}</div>
                                            <div><span>-</span> {pf.geoLocationAndDirectionsApis || 'Geo Location API, Directions API'}</div>
                                            <div><span>-</span> {pf.distanceMatrixAndMapsJsApis || 'Distance Matrix API, Maps Java Script API'}</div>

                                        </Box>
                                    </Box>
                                </Stack>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ background: '#FFF' }}
                                    className="APIKeyUpdateBottom"
                                >
                                    <Box className="bottom-left">
                                        <span>{pf.forAnyQueryContact || 'For any Query Contact:'}</span>
                                        <span>product.support@maventechlabs.com</span>
                                    </Box>
                                    <Box className="bottom-right">
                                        <Button
                                            variant="contained"
                                            style={{
                                                width: '30%',
                                                height: '41px',
                                                backgroundColor: '#fe5200',
                                                fontSize: '15px',
                                                textTransform: 'Uppercase',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                            }}
                                            onClick={() => onSave()}
                                        >
                                            {cs.save || 'Save'}
                                        </Button>
                                    </Box>
                                </Stack>
                            </> :
                            <Stack className="APIKeySecondTab">
                                <Box className="help-box">
                                    <Box className="help-section">
                                        <div >{pf.featureDisabledCreateKeys || 'This feature has been disabled for you. To enable create your Google Cloud Console and Google MAPs API Keys return and fill the details in Option 1.'}</div>
                                        <div><span>{pf.linkLabel || 'Link :'}</span> <span>{pf.howToCreateGoogleMapCloudConsole || 'How to create Google Map Cloud Console?'}</span></div>
                                        <div className='list'><span>1</span> {pf.stepGoCreateConsole || 'Go to and Create'} <a href="http://console.cloud.google.com/">http://console.cloud.google.com/</a> {pf.yourGoogleCloudConsole || 'your Google Clound Console'}</div>
                                        <div className='list'><span>2</span>  {pf.stepCreateProject || 'Create a Project for your Organization'}</div>
                                        <div className='list'><span>3</span> {pf.stepSetBilling || 'Set your Billing Account'}</div>
                                        <div className='list'><span>4</span> {pf.stepCreateApiKey || 'Create API Key under your project'}</div>
                                        <div className='list'><span>5</span> {pf.stepEnsureNotRestricted || 'Ensure the API Key ID is not application restricted'}</div>
                                        <div className='list'><span>6</span> {pf.stepEnsureApisEnabledFull || 'Ensure that following APIs are enabled for this API Key ID: Places API, Geo Coading API, Geo Locaiton API, Directions API, Distance Matrix API, Maps Java Script API'}</div>
                                    </Box>
                                    <Box className="help-section-bottum">
                                        <Box className="bottom-left">
                                            <span>{pf.forAnyQueryContact || 'For any Query Contact:'}</span>
                                            <span>product.support@maventechlabs.com</span>
                                        </Box>
                                    </Box>
                                </Box>
                            </Stack>
                    }
                </Stack>
                    :updateApi==2? <>
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ background: '#FFF' }}
                            className="UpdateSuccess"
                        >
                            <Box className="UpdateSuccessContent">
                                <Box className="message">{pf.apiKeyUpdatedSuccessfully || 'API Key Updated Successfully ! '}</Box>
                                <Box className="okButton">
                                    <Button
                                        variant="contained"
                                        style={{
                                            width: '20%',
                                            height: '41px',
                                            backgroundColor: '#fe5200',
                                            fontSize: '15px',
                                            textTransform: 'Uppercase',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                        }}
                                        onClick={() => updateModal(false, "APIKEYUPDATEMODAL")}
                                    >
                                        {cs.ok || 'OK'}
                                    </Button>
                                </Box>
                            </Box>
                        </Stack>
                    </>:
                    <>
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ background: '#FFF' }}
                        className="UpdateSuccess"
                    >
                        <Box className="UpdateSuccessContent">
                            <Box className="message">{pf.errorUpdatingKeys || 'Error in Updating the Keys. '}</Box>
                            <Box className="message">{pf.pleaseReferInstructions || 'Please refer Instructions for API Key ID !!'}</Box>
                            <Box className="okButton">
                                <Button
                                    variant="contained"
                                    style={{
                                        width: '20%',
                                        height: '41px',
                                        backgroundColor: '#fe5200',
                                        fontSize: '15px',
                                        textTransform: 'Uppercase',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                    }}
                                    onClick={() => updateModal(false, "APIKEYUPDATEMODAL")}
                                >
                                    {cs.ok || 'OK'}
                                </Button>
                            </Box>
                        </Box>
                    </Stack>
                </>
                    }
            </Modal >
        </>
    )
}

export default APIKeyUpdateModal